<template>
  <v-dialog v-model="active" max-width="1000px" persistent>
    <template v-slot:activator="{ on }">
      <slot name="activator" v-bind="{ on: on }" />
    </template>
    <v-card class="l-card">
      <v-container fluid class="background pa-0 l-card__title__container">
        <v-row align="center" class="ma-0 l-card__title__row">
          <v-col cols="12" class="pa-4">
            <span class="l-card__title__text">Checklist</span>
          </v-col>
          <v-btn absolute right top icon x-small color="#E5E8E7" @click="active = !active">
            <v-icon>fa fa-times</v-icon>
          </v-btn>
        </v-row>
      </v-container>
      <v-container fluid class="pa-0 l-card__content__container">
        <v-layout row wrap pa-5>
          <v-flex lg4>
            <span class="card_item_text_label">Contagem de animais</span>
          </v-flex>
          <v-flex lg4>
            <span class="card_item_text_label">Condições da propriedade</span>
          </v-flex>
          <v-flex lg4>
            <span class="card_item_text_label">Equipe de carregamento</span>
          </v-flex>
          <v-flex lg4>
            <span class="card_item_text_label_secondary">Machos</span>
          </v-flex>
          <v-flex lg4>
            <span class="card_item_text_label_secondary">Rampas de carregamento</span>
          </v-flex>
          <v-flex lg4>
            <span class="card_item_text_label_secondary">Uso de terceiro</span>
          </v-flex>
          <v-flex lg4>
            <span class="card_item_text_label_value">{{checkList.qtMachos}}</span>
          </v-flex>
          <v-flex lg4>
            <span class="card_item_text_label_value">{{checkList.qtRampas}}</span>
          </v-flex>
          <v-flex lg4>
            <span class="card_item_text_label_value">{{dsEquipeTerceira}}</span>
          </v-flex>
          <v-flex lg4>
            <span class="card_item_text_label_secondary">Fêmeas</span>
          </v-flex>
          <v-flex lg4>
            <span class="card_item_text_label_secondary">Suporta caminhão de 3 pisos</span>
          </v-flex>
          <v-flex lg4>
            <span class="card_item_text_label_secondary">Equipe</span>
          </v-flex>
          <v-flex lg4>
            <span class="card_item_text_label_value">{{checkList.qtFemeas}}</span>
          </v-flex>
          <v-flex lg4>
            <span class="card_item_text_label_value">{{checkList.tipoCaminhao.dsTipoCaminhao}}</span>
          </v-flex>
          <v-flex lg4>
            <span class="card_item_text_label_value">{{dsNomeEquipeTerceira}}</span>
          </v-flex>
          <v-flex lg4>
            <span class="card_item_text_label_secondary">Total</span>
          </v-flex>
          <v-flex lg4>
            <span class="card_item_text_label_secondary">Problemas com chuva</span>
          </v-flex>
          <v-flex lg4>
            <span class="card_item_text_label_secondary">Tempo de carregamento</span>
          </v-flex>
          <v-flex lg4>
            <span class="card_item_text_label_value">{{((checkList.qtMachos || 0) + (checkList.qtFemeas || 0))}}</span>
          </v-flex>
          <v-flex lg4>
            <span
              class="card_item_text_label_value"
            >{{checkList.tipoProblemaChuva.dsTipoProblemaChuva}}</span>
          </v-flex>
          <v-flex lg4>
            <span class="card_item_text_label_value">{{checkList.nrTempoCarregamento}}</span>
            <span class="card_item_text_label_suffix pl-1">Min.</span>
          </v-flex>
          <v-flex lg4>
            <v-spacer />
          </v-flex>
          <v-flex lg4>
            <v-spacer />
          </v-flex>
          <v-flex lg4>
            <span class="card_item_text_label_secondary">Equipe Interna</span>
          </v-flex>
          <v-flex lg4>
            <v-spacer />
          </v-flex>
          <v-flex lg4>
            <v-spacer />
          </v-flex>
          <v-flex lg4>
            <span class="card_item_text_label_value">{{checkList.qtEquipeInterna}}</span>
          </v-flex>
          <v-flex lg4>
            <v-spacer />
          </v-flex>
          <v-flex lg4>
            <v-spacer />
          </v-flex>
          <v-flex lg4>
            <span class="card_item_text_label_secondary">Equipe Terceirizada</span>
          </v-flex>
          <v-flex lg4>
            <v-spacer />
          </v-flex>
          <v-flex lg4>
            <v-spacer />
          </v-flex>
          <v-flex lg4>
            <span class="card_item_text_label_value">{{checkList.qtEquipeTerceira}}</span>
          </v-flex>
        </v-layout>
      </v-container>
      <v-card-actions class="pa-0 ma-0">
        <v-container fluid class="pa-0">
          <v-row class="ma-0 pa-2 px-4 pb-3">
            <v-btn depressed class="blue--text" @click="active = !active">Fechar</v-btn>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "DialogDadosChecklist",
  props: {
    checkList: {
      type: Object,
    },
  },
  data: () => ({
    active: false,
  }),
  methods: {},
  computed: {
    dsEquipeTerceira() {
      return this.checkList.flEquipeTerceirizada ? "Sim" : "Não";
    },
    dsNomeEquipeTerceira() {
      if (this.checkList.equipeTerceirizada.length > 0) {
        let nmEquipes = "";
        this.checkList.equipeTerceirizada.forEach((e) => {
          if (nmEquipes == "") {
            nmEquipes = e.dsTipoEquipeTerceirizada;
          } else {
            nmEquipes = nmEquipes + ", " + e.dsTipoEquipeTerceirizada;
          }
        });
        return nmEquipes;
      }
      return "Nenhuma";
    },
  },
};
</script>

<style>
.l-card {
}

.l-card__title__container {
  height: 54px;
  position: relative;
}

.l-card__title__row {
  height: 54px;
  position: relative;
}

.l-card__title__text {
  font: Regular 16px/21px Roboto;
  letter-spacing: 0;
  color: #e5e8e7;
}

.l-card__content__container {
  background: #f7f7f7 0 0 no-repeat padding-box;
  opacity: 1;
  position: relative;
  margin-top: 1%;
  width: 97%;
}

.card_item_text_label {
  text-align: left;
  font: bold 12px Roboto;
  letter-spacing: 0px;
  color: #10303d;
  opacity: 1;
}

.card_item_text_label_secondary {
  text-align: left;
  font: normal 10px Roboto;
  letter-spacing: 0px;
  color: #7b9596;
  opacity: 1;
}

.card_item_text_label_value {
  text-align: left;
  font: bold 24px Roboto;
  letter-spacing: 0px;
  color: #37565c;
  opacity: 1;
}

.card_item_text_label_suffix {
  text-align: left;
  font: normal 10px Roboto;
  letter-spacing: 0px;
  color: #7b9596;
  opacity: 1;
}
</style>
